import * as ActionTypes from './types';

export const xinshiUserSignup = (payload) => ({
  type: ActionTypes.XINSHI_USER_SIGNUP,
  payload
});



// WEBPACK FOOTER //
// ./src/components/actions/xinshi.js